<script lang="ts" setup>
import { ref } from 'vue'
import { useDialogPluginComponent } from 'quasar'
import BaseDialog from '@/components/base/BaseDialog.vue'

interface Props {
  message: string
  // isExecutingAction?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  // isExecutingAction: false,
  message: 'Voulez-vous vraiment supprimer le mot de passe de ce dossier?',
})

const emit = defineEmits([...useDialogPluginComponent.emits])
const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const isExecutingAction = ref(false)

async function confirmDelete() {
  isExecutingAction.value = true
  emit('ok')
}
</script>

<template>
  <q-dialog ref="dialogRef">
    <BaseDialog title="Supprimer" :is-dialog-loading="isExecutingAction" @on-dialog-cancel="onDialogCancel()"
      @hide="onDialogHide()">
      <template #body>
        {{ props.message }}
      </template>
      <template #actions>
        <q-btn flat label="Supprimer" @click="confirmDelete()" color="negative" />
      </template>
    </BaseDialog>
  </q-dialog>
</template>

<style lang="scss" scoped></style>
